export default class SessionStorageService {
    public saveArray(key: string, value: string[]) {
        if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, JSON.stringify(value));
            return;
        }

        // @ts-ignore
        const storedArray: string[] = JSON.parse(sessionStorage.getItem(key));
        storedArray.push(...value);
        sessionStorage.setItem(key, JSON.stringify(storedArray));
    }

    // @ts-ignore
    public valueExistsInArray(key: string, value: string) {
        if (!sessionStorage.getItem(key)) return false;

        if (sessionStorage.getItem(key)) {
            // @ts-ignore
            const currentArray: string[] = JSON.parse(sessionStorage.getItem(key));
            return currentArray.includes(value);
        }

    }
}
